import { ExpandedCourse } from "./coursesLoader";
import styles from "./Course.module.scss";
import Material from "./Material";
import { useLayoutData } from "../layout/myCoursesLayoutLoader";
import DisplayNotes from "./common/DisplayNotes";
import { useEffect, useRef } from "react";
import { Location, useLocation } from "react-router-dom";
import { areCourseIdsTheSame, CourseDeepLinkState } from "../coursesUtils.ts";
import { focusWithSetTabIndex } from "../../../../common/utils/focus.ts";
import NoMaterials from "./common/NoMaterials.tsx";

export default function Course({
  title,
  displayNotes,
  courseMaterials,
  id,
}: ExpandedCourse) {
  const containerRef = useRef<HTMLDivElement>(null);
  const { state: navState } =
    useLocation() as Location<CourseDeepLinkState | null>;
  const { config } = useLayoutData();

  useEffect(() => {
    if (
      navState?.courseId &&
      !navState?.materialId &&
      areCourseIdsTheSame(navState.courseId, id) &&
      containerRef.current
    ) {
      focusWithSetTabIndex(containerRef.current);
      containerRef.current.scrollIntoView();
    }
  }, [id, navState]);

  return (
    <div className={styles.courseContainer} ref={containerRef}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.notes}>
        <DisplayNotes displayNotes={displayNotes} />
      </div>
      {courseMaterials.length === 0 ? (
        <NoMaterials config={config} />
      ) : (
        <ul className={styles.materialList}>
          {courseMaterials.map((courseMaterial) => (
            <Material
              key={`${courseMaterial.id}:${courseMaterial.vbid}`}
              courseMaterial={courseMaterial}
            />
          ))}
        </ul>
      )}
    </div>
  );
}
